'use client'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { FC, useEffect, useState } from 'react'

dayjs.extend(duration)

export interface ITimer {
  initialTime: string | Date
  finalTime?: string | Date
  showHours?: boolean
  hideZeroHours?: boolean
  hideSeconds?: boolean
}

export const Timer: FC<ITimer> = ({
  initialTime,
  showHours = false,
  hideZeroHours = true,
  finalTime,
  hideSeconds = false,
}): string => {
  const [differenceTime, setDifferenceTime] = useState<number>(
    dayjs(finalTime).diff(initialTime)
  )

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null

    if (!finalTime) {
      intervalId = setInterval(() => {
        setDifferenceTime(dayjs().diff(initialTime))
      }, 1000)
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [finalTime, initialTime])

  const minutesSeconds = dayjs(differenceTime).format('mm:ss')
  const minutes = dayjs(differenceTime).format('mm')
  const hoursWithDays = String(
    Math.trunc(dayjs.duration(differenceTime).asHours())
  ).padStart(2, '0')

  if (showHours) {
    return `${hoursWithDays}:${minutesSeconds}`
  }

  if (hideSeconds) {
    return `${hoursWithDays}:${minutes}`
  }

  if (hideZeroHours) {
    if (hoursWithDays !== '00') {
      return `${hoursWithDays}:${minutesSeconds}`
    }

    return minutesSeconds
  }
  return minutesSeconds
}
